import * as React from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'
import { useFormContext, useWatch } from 'react-hook-form'

import * as styles from './GridMultiSelect.module.scss'

const toKey = (rowValue, colValue) => `${rowValue}::${colValue}`

export const GridMultiSelect = ({
  name,
  label,
  rows = [],
  columns = [],
  required,
  disabled,
  error,
  fieldStyle,
}) => {
  const { control, setValue } = useFormContext()
  const selected = useWatch({ control, name }) || []

  const toggle = (rowValue, colValue) => {
    const key = toKey(rowValue, colValue)
    const next = selected.includes(key)
      ? selected.filter(value => value !== key)
      : [...selected, key]
    setValue(name, next, { shouldDirty: true, shouldValidate: true })
  }

  return (
    <div className={styles.gridWrapper} style={fieldStyle}>
      {!!label && (
        <div className={styles.label}>
          {label}
          {required ? <span className={styles.asterisk}>*</span> : null}
        </div>
      )}
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.cornerCell}></th>
            {columns.map(column => (
              <th key={column.value} className={styles.columnHeader}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr key={row.value}>
              <td className={styles.rowHeader}>{row.label}</td>
              {columns.map(column => {
                const key = toKey(row.value, column.value)
                const checked = selected.includes(key)
                return (
                  <td key={key} className={styles.cell}>
                    <Checkbox
                      size="medium"
                      checked={checked}
                      onChange={() => toggle(row.value, column.value)}
                      disabled={disabled}
                    />
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {error && (
        <FormHelperText className={styles.error} error={!!error}>
          {error.message}
        </FormHelperText>
      )}
    </div>
  )
}

